var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2555 7.60198C17.2573 7.73355 17.2361 7.8572 17.1918 7.97295C17.1476 8.08869 17.0719 8.19664 16.9648 8.2968L9.85044 14.9075C9.63485 15.1079 9.37717 15.2101 9.0774 15.2142C8.77763 15.2182 8.5169 15.1231 8.2952 14.9287C8.07423 14.7344 7.96196 14.5056 7.95837 14.2425C7.95478 13.9793 8.06078 13.7476 8.27637 13.5473L13.5583 8.63931L1.3347 8.80595C1.02547 8.81017 0.769523 8.71891 0.566853 8.53218C0.364182 8.34545 0.260945 8.11263 0.257143 7.83371C0.253331 7.55413 0.354544 7.31819 0.56078 7.12588C0.767017 6.93358 1.02512 6.83564 1.33508 6.83208L13.5314 6.66581L8.11764 1.90364C7.89667 1.70927 7.7844 1.48051 7.78081 1.21738C7.77722 0.954244 7.88322 0.722516 8.09881 0.52219C8.3144 0.321864 8.57244 0.219652 8.87293 0.215555C9.17343 0.211459 9.4338 0.306604 9.65404 0.500988L16.946 6.91535C17.0565 7.01253 17.1354 7.11837 17.1828 7.23287C17.2302 7.34737 17.2545 7.4704 17.2555 7.60198Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.03328abab0674c2b058dd785f5101d52.svg";
export { ForwardRef as ReactComponent };